export default __webpack_public_path__ + "static/media/sort-algo.0a0f39b2.gif";